import { unsetJWT } from '../reducers/user';

// Only drops the token: the App shell sends the user back to the login page once it is gone.
export const authMiddleware = store => next => action => {
  if (action.type.endsWith('rejected') && (action.error?.message === 'Request failed with status code 401'))
    store.dispatch(unsetJWT());
  return next(action);
};
